import { brand } from '../../config/brand';

export default function SiteHeader() {
  return (
    <div className="border-b border-slate-800 bg-slate-950/95 sticky top-0 z-50 backdrop-blur-md">
      <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between gap-3">
        <a
          href={brand.mainDomain}
          rel="home"
          className="flex items-center gap-3 group min-w-0"
          title={`${brand.name} — Size Converter`}
        >
          <img
            src={brand.logoPath}
            alt={`${brand.name} logo`}
            width={44}
            height={44}
            className="rounded-xl shrink-0 ring-1 ring-slate-700/80 group-hover:ring-emerald-500/50 transition-shadow"
          />
          <div className="min-w-0 text-left leading-tight">
            <span className="block font-semibold text-white text-sm sm:text-base truncate group-hover:text-emerald-400 transition-colors">
              {brand.name}
            </span>
            <span className="block text-xs text-slate-500 truncate">Size Converter</span>
          </div>
        </a>
        <span className="hidden sm:inline text-xs text-slate-600 font-mono truncate max-w-[260px]">
          {brand.subdomain}
        </span>
      </div>
    </div>
  );
}
